module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/6@2x_4b652530a0ca5bdd4d1819ebf65c36a9.png";